import React, { useState, useRef, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  FeatureGroup,
  LayersControl
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import 'leaflet-editable';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import {
  FaChevronDown,
  FaChevronUp,
  FaMoneyBillAlt,
  FaBuilding,
  FaExclamationTriangle,
} from "react-icons/fa";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Expand } from "../../../../Components/IconComponents";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { GeoJSON, useMapEvents, useMap } from "react-leaflet";
import { getAllDistricts, gisCoordinatesData, gisBlockCoordinatesData, gisStateCoordinates, gisPanchayatCoordinatesData, gisVillageCoordinatesData, getfeaturefacility, getfacilitydatasearch } from "../../../../Services/EndPoints";
import { toast } from "react-toastify";
import { getData } from "../../../../Services/Services";
import { text } from "@fortawesome/fontawesome-svg-core";
import Loader from "react-spinner-loader";
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';


// Custom Icons using SVG strings
const createCustomIcon = (svg, color) => {
  return L.divIcon({
    className: "custom-icon",
    html: `<div style="color: ${color}; font-size: 24px;">${svg}</div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12],
  });
};
const redDotIcon = new L.Icon({
  iconUrl: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red"><circle cx="12" cy="12" r="10"/></svg>',
  iconSize: [12, 12],
  iconAnchor: [12, 12],
  popupAnchor: [0, -12],
});
const invisibleIcon = new L.Icon({
  iconUrl:
    'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"></svg>',
  iconSize: [1, 1], // minimal size to avoid visible area
  iconAnchor: [0, 0],
  popupAnchor: [0, 0],
});
const atmIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="none">
  <rect x="32" y="64" width="384" height="384" rx="24" fill="#333" stroke="#333" stroke-width="16"/>
  <rect x="96" y="112" width="256" height="96" rx="8" fill="#fff" stroke="#333" stroke-width="8"/>
  <rect x="96" y="232" width="256" height="32" rx="4" fill="#fff" stroke="#333" stroke-width="8"/>
  <circle cx="144" cy="296" r="12" fill="#fff"/>
  <circle cx="176" cy="296" r="12" fill="#fff"/>
  <circle cx="208" cy="296" r="12" fill="#fff"/>
  <circle cx="144" cy="328" r="12" fill="#fff"/>
  <circle cx="176" cy="328" r="12" fill="#fff"/>
  <circle cx="208" cy="328" r="12" fill="#fff"/>
</svg>`;

const facilityIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 64 64" fill="none">
  <rect x="8" y="20" width="48" height="36" rx="2" ry="2" fill="#E6F0FF" stroke="#333" stroke-width="2"/>
  <rect x="16" y="28" width="8" height="8" fill="#007BFF" stroke="#007BFF" stroke-width="1"/>
  <rect x="28" y="28" width="8" height="8" fill="#007BFF" stroke="#007BFF" stroke-width="1"/>
  <rect x="40" y="28" width="8" height="8" fill="#007BFF" stroke="#007BFF" stroke-width="1"/>
  <rect x="28" y="40" width="8" height="12" fill="#FF4136" stroke="#333" stroke-width="1.5"/>
  <path d="M8 20 L32 8 L56 20" stroke="#333" stroke-width="2" fill="none"/>
</svg>
`;
const branchIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="#B22222">
  <path d="M0 464V256H64V464H160V352H288V464H384V320H512V464H640V224L320 0 0 224V464z"/>
</svg>`;

const incidentIconSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>';

// Create icon instances
const facilityIconSvg1 = createCustomIcon(facilityIconSvg, "#0066cc");
const branchIcon = createCustomIcon(branchIconSvg, "#006600");
const incidentIcon = createCustomIcon(incidentIconSvg, "#cc0000");
const bmskIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#cc0000">
  <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 464c-114.7 0-208-93.3-208-208S141.3 48 256 48s208 93.3 208 208-93.3 208-208 208zm96-288c0-53-43-96-96-96s-96 43-96 96c0 42.5 27.6 78.6 66 91.2V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-92.8c38.4-12.6 66-48.7 66-91.2zm-96 64c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"/>
</svg>`;
const triangleIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="40" height="40">
  <rect x="8" y="20" width="48" height="36" rx="2" ry="2" fill="#1E88E5"/>
  <rect x="16" y="28" width="6" height="6" fill="#BBDEFB"/>
  <rect x="26" y="28" width="6" height="6" fill="#BBDEFB"/>
  <rect x="36" y="28" width="6" height="6" fill="#BBDEFB"/>
  <rect x="16" y="38" width="6" height="6" fill="#BBDEFB"/>
  <rect x="26" y="38" width="6" height="6" fill="#BBDEFB"/>
  <rect x="36" y="38" width="6" height="6" fill="#BBDEFB"/>
  <rect x="28" y="46" width="8" height="10" fill="#0D47A1"/>
</svg>`;
const bmskWeatherIconSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" width="32" height="32">
  <!-- Red background circle -->
  <circle cx="60" cy="60" r="60" fill="#f9385b"/>
  
  <!-- Map pin -->
  <path fill="#ffffff" d="M64 30a24 24 0 0 0-24 24c0 18 24 40 24 40s24-22 24-40a24 24 0 0 0-24-24zm0 36a12 12 0 1 1 0-24 12 12 0 0 1 0 24z"/>

  <!-- Cloud and rain inside the pin -->
  <g transform="translate(52,52) scale(0.5)">
    <path d="M24 10a8 8 0 00-7.5 5.2A6 6 0 1012 26h20a6 6 0 100-12 8 8 0 00-8-8z" fill="#f9385b"/>
    <circle cx="18" cy="32" r="2" fill="#f9385b"/>
    <circle cx="24" cy="36" r="2" fill="#f9385b"/>
    <circle cx="30" cy="32" r="2" fill="#f9385b"/>
  </g>
</svg>
`;

const triangleIcon = createCustomIcon(triangleIconSvg, "#0deb0dff");

const bmskIcon = L.divIcon({
  className: "bmsk-weather-icon",
  html: `<div style="font-size: 50px;">${bmskWeatherIconSvg}</div>`,
  iconSize: [100, 100],
  iconAnchor: [16, 16],
  popupAnchor: [0, -16],
});


// Color-coded incident icons based on severity
const getIncidentIcon = (severity) => {
  const colors = {
    Low: "#ffcc00", // Yellow
    Medium: "#ff9900", // Orange
    High: "#cc0000", // Red
    Critical: "#990000", // Dark Red
  };

  return createCustomIcon(incidentIconSvg, colors[severity] || "#cc0000");
};



const RMMap = ({ selectedDistrictIds, selectedDistrictId, selectedBlockIds, isLoading, selectedRegions, selectedPanchayatIds, selectedVillageIds, selectedFacilities, mapData1, onLocationSelect, facilityCoordinates, bmskdetails, drawCircle,
  circleRadius, clearCircles, drawPolygon,
  clearPolygons, selectedBmskids, handleDrawCreated, handleDrawDeleted, clickedPoint, setClickedPoint, bmskActiveDistricts, isKilometerEnabled, searchCoordinates, }) => {
  const handle = useFullScreenHandle();
  const [showATMs, setShowATMs] = useState(false);
  const [showBranches, setShowBranches] = useState(true);
  const [showIncidents, setShowIncidents] = useState(false);
  const [showServices, setShowServices] = useState(true);
  const [showRegionHierarchy, setShowRegionHierarchy] = useState(true);
  const [activeTab, setActiveTab] = useState("Region");
  const [kilometerRange, setKilometerRange] = useState(40);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showDistricts, setShowDistricts] = useState(false);
  const [DistrictList, setDistrictList] = useState([]);
  // const [selectedPanchayatIds, setSelectedPanchayatIds] = useState([]);
  // const [selectedVillageIds, setSelectedVillageIds] = useState([]);
  const [panchayatLayers, setPanchayatLayers] = useState({});
  const [villageLayers, setVillageLayers] = useState({});
  const [districtCoordinates, setDistrictCoordinates] = useState({});
  const [panchayatNamenew, setpanchayatNamenew] = useState({});
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedData, setSelectedData] = useState({});
  const [loadingId, setLoadingId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [bmskLayers, setBmskLayers] = useState({});
  const [mapData, setMapData] = useState({
    branches: [],
    atms: [],
    incidents: [],
  });
  const [selectedLayers, setSelectedLayers] = useState({
    regionLayer: true,
    state: false,
    block: true,
  });
  const [loadingStates, setLoadingStates] = useState({
    districts: false,
    blocks: false,
    mapData: false
  });


  const [drawnShapes, setDrawnShapes] = useState([]);
  const [districtLayers, setDistrictLayers] = useState({});
  const [blockLayers, setBlockLayers] = useState({});
  const [filteredEntities, setFilteredEntities] = useState({
    branches: null,

    atms: null,

    incidents: null,
  });

  const [stateGeoJSON, setStateGeoJSON] = useState(null);

  const [districtGeoJSON, setDistrictGeoJSON] = useState({});

  const [activeDistricts, setActiveDistricts] = useState({});
  // const [showDistricts, setShowDistricts] = useState(false); // Controls visibility
  const [selectAllDistricts, setSelectAllDistricts] = useState(false); // Controls selection

  // Create a list of unique districts from branches
  const [districts, setDistricts] = useState([]);
  const [Coordinates, setCoordinates] = useState([]);
  const [allDistrictsSelected, setAllDistrictsSelected] = useState(false);
  const [circles, setCircles] = useState([]);
  const drawRef = useRef();
  const mapRef = useRef(null);
  const featureGroupRef = useRef(null);

  const [editableCircle, setEditableCircle] = useState(null);

  const [polygons, setPolygons] = useState([]);
  const [editablePolygon, setEditablePolygon] = useState(null);


  const [filteredFacilities, setFilteredFacilities] = useState([]);
  const [Filterfacility, setFilterfacility] = useState([])

  // Update the circle/polygon effects to track shapes

  useEffect(() => {
    console.log('Filtered facilities:', filteredFacilities);
  }, [filteredFacilities]);

  useEffect(() => {
    console.log('Drawn shapes:', drawnShapes);
  }, [drawnShapes]);


  useEffect(() => {
    getFacilityData()
  }, [drawPolygon, drawCircle,])


  const getFacilityData = async () => {
    const response = await getData(getfacilitydatasearch);
    if (response) {

      setFilterfacility(response);
    }
  };


  useEffect(() => {
    if (drawCircle && circleRadius && mapRef.current) {
      const map = mapRef.current;

      if (!map.editTools) {
        map.editTools = new L.Editable(map);
      }

      // Clear any existing circle
      if (editableCircle) {
        editableCircle.disableEdit();
        editableCircle.remove();
      }

      const center = map.getCenter();
      const circle = map.editTools.startCircle(center, circleRadius, {
        color: '#3388ff',
        fillColor: '#3388ff',
        fillOpacity: 0.2
      });

      circle.enableEdit();

      const updateCircleShape = () => {
        const center = circle.getLatLng();
        const radius = circle.getRadius();

        // Create a proper GeoJSON representation of the circle
        const circleGeoJSON = {
          type: "Feature",
          properties: {
            isCircle: true,
            center: [center.lat, center.lng],
            radius: radius
          },
          geometry: {
            type: "Polygon",
            coordinates: [getCirclePoints(center.lat, center.lng, radius)]
          }
        };

        setDrawnShapes([circleGeoJSON]);
      };

      circle.on('editable:editing', updateCircleShape);
      circle.on('editable:vertex:dragend', updateCircleShape);

      // Initial update
      updateCircleShape();

      setEditableCircle(circle);
    }
  }, [drawCircle, circleRadius]);

  // Helper function to generate circle points
  const getCirclePoints = (lat, lng, radius) => {
    const points = [];
    for (let i = 0; i <= 360; i += 10) {
      const angle = (i * Math.PI) / 180;
      const point = {
        lat: lat + (radius / 111320) * Math.cos(angle), // approx meters to degrees
        lng: lng + (radius / (111320 * Math.cos((lat * Math.PI) / 180))) * Math.sin(angle)
      };
      points.push([point.lng, point.lat]);
    }
    // Close the circle
    points.push(points[0]);
    return points;
  };

  useEffect(() => {
    if (drawPolygon && mapRef.current) {
      const map = mapRef.current;

      if (!map.editTools) {
        map.editTools = new L.Editable(map);
      }

      const polygon = map.editTools.startPolygon();
      polygon.enableEdit();

      polygon.on('editable:editing', () => {
        const geoJSON = polygon.toGeoJSON();
        setDrawnShapes([geoJSON]);
      });

      setEditablePolygon(polygon);
    }
  }, [drawPolygon]);




  // Helper distance calculation
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Earth radius in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  // Clear circles
  useEffect(() => {
    if (clearCircles) {
      if (editableCircle) {
        editableCircle.disableEdit();
        editableCircle.remove();
        setEditableCircle(null);
      }
      if (featureGroupRef.current) {
        featureGroupRef.current.clearLayers();
      }

      setDrawnShapes([]);              // clear shapes first
      setFilteredFacilities([]);       // clear all filtered markers

      setTimeout(() => {
        setFilteredFacilities([]);     // keep; but value should be []
      }, 10);
    }
  }, [clearCircles, editableCircle, featureGroupRef]);

  useEffect(() => {
    if (clearPolygons) {
      // Clear the drawn polygon first
      if (editablePolygon) {
        editablePolygon.disableEdit();
        editablePolygon.remove();
        setEditablePolygon(null);
      }
      if (featureGroupRef.current) {
        const layerGroup = featureGroupRef.current;
        layerGroup.clearLayers();
      }

      // Clear states in correct order
      setDrawnShapes([]);

      // Use setTimeout to ensure state updates properly
      setTimeout(() => {
        setFilteredFacilities([]);
      }, 10);
    }
  }, [clearPolygons]);


  useEffect(() => {
    // ✅ Clear immediately when shapes are removed
    if (!drawnShapes || drawnShapes.length === 0) {
      setFilteredFacilities([]);
      return;
    }

    if (drawnShapes.length > 0 && Filterfacility && Filterfacility.length > 0) {
      const filtered = Filterfacility.filter(facility => {
        // ✅ Skip if no valid ID
        if (!facility.id || facility.id === '' || facility.id === null || facility.id === undefined) {
          return false;
        }

        // ✅ Skip if no valid coordinates
        if (!facility.latitude || !facility.longitude ||
          isNaN(facility.latitude) || isNaN(facility.longitude)) {
          return false;
        }

        const point = [facility.longitude, facility.latitude];

        return drawnShapes.some(shape => {
          if (shape.properties?.isCircle) {
            const center = shape.properties.center;
            const radius = shape.properties.radius;

            if (!center || !Array.isArray(center) || center.length < 2 || !radius) {
              return false;
            }

            const distance = calculateDistance(
              center[0], center[1],
              facility.latitude, facility.longitude  // ✅ Fixed: use facility coords, not point
            );
            return distance <= (radius / 1000);
          } else {
            try {
              return booleanPointInPolygon(point, shape);
            } catch (error) {
              return false;
            }
          }
        });
      });
      setFilteredFacilities(filtered);
    } else {
      setFilteredFacilities([]);
    }
  }, [drawnShapes, Filterfacility]);





  useEffect(() => {
    // Assuming DistrictList contains all possible districts
    setAllDistrictsSelected(selectedDistrictIds.length === DistrictList.length);
  }, [selectedDistrictIds, DistrictList]);
  useEffect(() => {

    if (selectedDistrictIds.length > 0 && mapRef.current) {
      const map = mapRef.current;

      // If all districts are selected (Bihar is selected)
      if (selectedDistrictIds.length === DistrictList.length) {
        if (stateGeoJSON) {
          const tempLayer = L.geoJSON(stateGeoJSON);
          const bounds = tempLayer.getBounds();
          map.flyToBounds(bounds, {
            padding: [50, 50],
            duration: 1,
            maxZoom: 8
          });
        }
      }
      // If specific districts are selected
      else {
        const bounds = new L.LatLngBounds();
        let hasValidBounds = false;

        selectedDistrictIds.forEach(districtId => {
          const districtLayer = districtLayers[districtId];
          if (districtLayer) {
            const tempLayer = L.geoJSON(districtLayer);
            bounds.extend(tempLayer.getBounds());
            hasValidBounds = true;
          }
        });

        if (hasValidBounds) {
          map.flyToBounds(bounds, {
            padding: [50, 50],
            duration: 1,
            maxZoom: selectedDistrictIds.length === 1 ? 10 : 9
          });
        } else if (stateGeoJSON) {
          // Fallback to state bounds if no valid district bounds
          const tempLayer = L.geoJSON(stateGeoJSON);
          map.flyToBounds(tempLayer.getBounds(), {
            padding: [50, 50],
            duration: 1,
            maxZoom: 8
          });
        }
      }
    }
  }, [selectedDistrictIds, districtLayers, stateGeoJSON, DistrictList.length]);


  useEffect(() => {
    if (searchCoordinates && mapRef.current) {
      const map = mapRef.current;
      const tempLayer = L.geoJSON(searchCoordinates);
      const bounds = tempLayer.getBounds();
      map.flyToBounds(bounds, {
        padding: [50, 50],
        duration: 1,
        maxZoom: 22
      });
    }
  }, [searchCoordinates]);



  const LocationMarker = ({ onLocationSelect }) => {
    useMapEvents({
      click(e) {
        console.log('Map clicked at:', e.latlng);
        const { lat, lng } = e.latlng;

        // Store the clicked point
        setClickedPoint({
          lat,
          lng,
          timestamp: Date.now() // Add timestamp to force re-render if clicking same spot
        });
        onLocationSelect({
          latitude: e.latlng.lat,
          longitude: e.latlng.lng
        });
      }
    });
    return clickedPoint ? (
      <Marker
        position={[clickedPoint.lat, clickedPoint.lng]}
        icon={!isKilometerEnabled ? invisibleIcon : redDotIcon}
        interactive={true}
      >
        {/* <Popup>
        <div>
          <strong>Coordinates:</strong><br />
          Latitude: {clickedPoint.lat.toFixed(6)}<br />
          Longitude: {clickedPoint.lng.toFixed(6)}
        </div>
      </Popup> */}
      </Marker>
    ) : null;
  };
  useEffect(() => {
    if (selectedBlockIds.length > 0 && mapRef.current && Object.keys(blockLayers).length > 0) {
      const map = mapRef.current;
      const bounds = new L.LatLngBounds();
      let hasValidBounds = false;

      selectedBlockIds.forEach(blockId => {
        const blockLayer = blockLayers[blockId];
        if (blockLayer) {
          const tempLayer = L.geoJSON(blockLayer);
          bounds.extend(tempLayer.getBounds());
          hasValidBounds = true;
        }
      });

      if (hasValidBounds) {
        map.flyToBounds(bounds, {
          padding: [50, 50],
          duration: 1,
          maxZoom: 14
        });
      }
    }
  }, [selectedBlockIds, blockLayers]);

  useEffect(() => {
    if (selectedPanchayatIds.length > 0 && mapRef.current && Object.keys(panchayatLayers).length > 0) {
      const map = mapRef.current;
      const bounds = new L.LatLngBounds();
      let hasValidBounds = false;

      selectedPanchayatIds.forEach(panchayatId => {
        const panchayatLayer = panchayatLayers[panchayatId];
        if (panchayatLayer) {
          const tempLayer = L.geoJSON(panchayatLayer);
          bounds.extend(tempLayer.getBounds());
          hasValidBounds = true;
        }
      });

      if (hasValidBounds) {
        map.flyToBounds(bounds, {
          padding: [50, 50],
          duration: 1,
          maxZoom: 16
        });
      }
    }
  }, [selectedPanchayatIds, panchayatLayers]);

  useEffect(() => {
    if (selectedVillageIds.length > 0 && mapRef.current && Object.keys(villageLayers).length > 0) {
      const map = mapRef.current;
      const bounds = new L.LatLngBounds();
      let hasValidBounds = false;

      selectedVillageIds.forEach(villageId => {
        const villageLayer = villageLayers[villageId];
        if (villageLayer) {
          const tempLayer = L.geoJSON(villageLayer);
          bounds.extend(tempLayer.getBounds());
          hasValidBounds = true;
        }
      });

      if (hasValidBounds) {
        map.flyToBounds(bounds, {
          padding: [50, 50],
          duration: 1,
          maxZoom: 18
        });
      }
    }
  }, [selectedVillageIds, villageLayers]);




  useEffect(() => {
    const fetchLayers = async () => {
      if (isLoading) {
        setLoader(true);
        return;
      }

      try {
        setLoader(true);

        // Fetch district layers
        const districtPromises = selectedDistrictIds.map(async (gisId) => {
          try {
            const response = await getData(gisCoordinatesData + gisId);
            return response && response.length > 0
              ? { gisId, geoJson: JSON.parse(response[0].coordinates) }
              : null;
          } catch (error) {
            console.error(`Error fetching district ${gisId}:`, error);
            return null;
          }
        });
        // Safe BMSK layer fetch
        const bmskPromises = Array.isArray(selectedBmskids)
          ? selectedBmskids.map(async (gisId) => {
            try {
              const response = await getData(gisCoordinatesData + gisId);
              return response && response.length > 0
                ? { gisId, geoJson: JSON.parse(response[0].coordinates) }
                : null;
            } catch (error) {
              console.error(`Error fetching BMSK ${gisId}:`, error);
              return null;
            }
          })
          : [];

        const bmskResults = await Promise.all(bmskPromises);

        const newBmskLayers = {};
        bmskResults?.forEach(result => {
          if (result) newBmskLayers[result.gisId] = result.geoJson;
        });
        setBmskLayers(newBmskLayers);


        // Fetch block layers
        const blockPromises = selectedBlockIds.map(async (gisId) => {
          try {
            const response = await getData(gisBlockCoordinatesData + gisId);
            return response && response.length > 0
              ? { gisId, geoJson: JSON.parse(response[0].coordinates) }
              : null;
          } catch (error) {
            console.error(`Error fetching block ${gisId}:`, error);
            return null;
          }
        });

        // Fetch panchayat layers
        // In your fetchLayers function, modify the panchayatPromises part:
        const panchayatPromises = selectedPanchayatIds.map(async (gisId) => {
          try {
            const response = await getData(gisPanchayatCoordinatesData + gisId);
            if (response && response.length > 0) {
              return {
                gisId,
                geoJson: JSON.parse(response[0].coordinates),
                name: response[0].gpname // Store the name from the response
              };
            }
            return null;
          } catch (error) {
            console.error(`Error fetching panchayat ${gisId}:`, error);
            return null;
          }
        });
        // Fetch village layers
        const villagePromises = selectedVillageIds.map(async (gisId) => {
          try {
            const response = await getData(gisVillageCoordinatesData + gisId);
            return response && response.length > 0
              ? { gisId, geoJson: JSON.parse(response[0].coordinates) }
              : null;
          } catch (error) {
            console.error(`Error fetching village ${gisId}:`, error);
            return null;
          }
        });

        const [districtResults, blockResults, panchayatResults, villageResults] = await Promise.all([
          Promise.all(districtPromises),
          Promise.all(blockPromises),
          Promise.all(panchayatPromises),
          Promise.all(villagePromises)
        ]);

        // Process results
        const newDistrictLayers = {};
        districtResults.forEach(result => {
          if (result) newDistrictLayers[result.gisId] = result.geoJson;
        });


        const newBlockLayers = {};
        blockResults.forEach(result => {
          if (result) newBlockLayers[result.gisId] = result.geoJson;
        });

        // In the fetchLayers function, modify how you process panchayat results:
        const newPanchayatLayers = {};
        const panchayatNames = {}; // New object to store names

        panchayatResults.forEach(result => {
          if (result) {
            newPanchayatLayers[result.gisId] = result.geoJson;
            panchayatNames[result.gisId] = result.name; // Store the name
          }
        });

        setPanchayatLayers(newPanchayatLayers);
        setpanchayatNamenew(panchayatNames); // Store all names in state

        const newVillageLayers = {};
        villageResults.forEach(result => {
          if (result) newVillageLayers[result.gisId] = result.geoJson;
        });

        setDistrictLayers(newDistrictLayers);
        setBlockLayers(newBlockLayers);
        // setPanchayatLayers(newPanchayatLayers);
        setVillageLayers(newVillageLayers);
      } catch (error) {
        console.error("Error fetching layers:", error);
      } finally {
        setLoader(false);
      }
    };

    if (selectedDistrictIds || selectedBlockIds ||
      selectedPanchayatIds || selectedVillageIds) {
      fetchLayers();
    } else {
      setDistrictLayers({});
      setBlockLayers({});
      setPanchayatLayers({});
      setVillageLayers({});
      setLoader(false);
    }
  }, [selectedDistrictIds, selectedBlockIds, selectedPanchayatIds, selectedVillageIds, isLoading]);


  useEffect(() => {

    fetchDistrictList();
    fetchCoordinates();
    mapStateCoordinates();
  }, []);

  useEffect(() => {
    if (selectedBmskids && selectedBmskids.length > 0 && mapRef.current && Object.keys(bmskLayers).length > 0) {
      const map = mapRef.current;
      const bounds = new L.LatLngBounds();
      let hasValidBounds = false;

      selectedBmskids.forEach(bmskId => {
        const bmskLayer = bmskLayers[bmskId];
        if (bmskLayer) {
          const tempLayer = L.geoJSON(bmskLayer);
          bounds.extend(tempLayer.getBounds());
          hasValidBounds = true;
        }
      });

      if (hasValidBounds) {
        map.flyToBounds(bounds, {
          padding: [50, 50],
          duration: 1,
          maxZoom: 10 // Adjust this zoom level as needed for BMSK districts
        });
      }
    }
  }, [selectedBmskids, bmskLayers]);

  // Extract unique districts from branches after data is loaded
  useEffect(() => {
    if (mapData.branches.length > 0) {
      const uniqueDistricts = [
        ...new Set(mapData.branches.map((branch) => branch.district)),
      ];
      setDistricts(uniqueDistricts);
    }
  }, [mapData.branches]);


  const filterEntitiesInShapes = (shapes) => {
    if (!shapes || shapes.length === 0) {
      // No shapes, reset filters

      setFilteredEntities({
        branches: null,

        atms: null,

        incidents: null,
      });

      return;
    }

    // Filter branches

    const branchesInShapes = mapData.branches.filter((branch) => {
      return shapes.some((shape) => {
        return booleanPointInPolygon(
          [parseFloat(branch.position[1]), parseFloat(branch.position[0])],

          shape
        );
      });
    });

    // Filter ATMs

    const atmsInShapes = mapData.atms.filter((atm) => {
      return shapes.some((shape) => {
        return booleanPointInPolygon(
          [parseFloat(atm.position[1]), parseFloat(atm.position[0])],

          shape
        );
      });
    });

    // Filter incidents

    const incidentsInShapes = mapData.incidents.filter((incident) => {
      return shapes.some((shape) => {
        return booleanPointInPolygon(
          [parseFloat(incident.position[1]), parseFloat(incident.position[0])],

          shape
        );
      });
    });

    setFilteredEntities({
      branches: branchesInShapes,

      atms: atmsInShapes,

      incidents: incidentsInShapes,
    });
  };





  // Process the response data into the format needed for the map
  const processResponseData = (data) => {
    // Check if the data has the expected structure
    if (!data.branches_list || !data.atms_list || !data.incidents_list) {
      console.error("Data missing required lists");
      // toast.error("Data format is incorrect");
      return;
    }

    // Transform branches data
    const branches = data.branches_list.map((branch) => ({
      id: branch.id,
      name: branch.branchName,
      position: [
        parseFloat(branch.latitude) || 25.59, // Fallback coordinates if missing
        parseFloat(branch.longitude) || 85.13,
      ],
      manager:
        branch.branch_contact && branch.branch_contact.length > 0
          ? `${branch.branch_contact[0].firstName} ${branch.branch_contact[0].lastName}`
          : "N/A",
      phones: branch.phoneNumber || "N/A",
      email: branch.email || "N/A",
      address: `${branch.addressLine1} ${branch.addressLine2 || ""}`,
      district: branch.district || "N/A",
      ifscCode: branch.ifscCode || "N/A",
      // Include original data to access all fields if needed
      originalData: branch,
    }));

    // Transform ATMs data
    const atms = data.atms_list.map((atm) => ({
      id: atm.id,
      name: atm.name,
      position: [
        parseFloat(atm.latitude) || 25.59, // Fallback coordinates if missing
        parseFloat(atm.longitude) || 85.13,
      ],
      status: atm.activeStatus ? "Working" : "Inactive",
      code: atm.code || "N/A",
      address: atm.addressLine || "N/A",
      district: atm.district || "N/A",
      // Include original data
      originalData: atm,
    }));

    // Transform incidents data
    const incidents = data.incidents_list.map((incident) => ({
      id: incident.id,
      type: incident.incidentName,
      position: [
        parseFloat(incident.latitude) || 25.59, // Fallback coordinates if missing
        parseFloat(incident.longitude) || 85.13,
      ],
      severity: incident.severityLevel || "Medium",
      date: new Date(incident.incidentDateAndTime).toISOString().split("T")[0],
      reporter: incident.reporterName,
      description: incident.description,
      affectedServices: incident.affectedServices,
      // Include original data
      originalData: incident,
    }));

    // Set the processed data to state
    setMapData({ branches, atms, incidents });
  };

  const toggleFullscreen = () => {
    if (isFullscreen) {
      handle.exit();
    } else {
      handle.enter();
    }
    setIsFullscreen(!isFullscreen);
  };
  const handleCheckboxChange = (key) => {
    setSelectedLayers((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));

    if (key === "state") {
      // Toggle select all without affecting visibility
      setSelectAllDistricts(!selectAllDistricts);

      // Update individual district selections
      const newActiveDistricts = {};
      DistrictList.forEach((district) => {
        newActiveDistricts[district.value] = !selectAllDistricts;
      });
      setActiveDistricts(newActiveDistricts);

      // If selecting all, fetch coordinates for all districts
      if (!selectAllDistricts) {
        const allGisIds = DistrictList.map((district) => district.gis_id);
        // You might want to handle multiple coordinate fetches here
        // For example, fetch coordinates for the first district
        if (DistrictList.length > 0) {
          fetchCoordinates(DistrictList[0].gis_id);
        }
      }
    }
  };

  const handleDistrictToggle = async (districtName) => {
    const newActiveDistricts = {
      ...activeDistricts,
      [districtName]: !activeDistricts[districtName],
    };
    setActiveDistricts(newActiveDistricts);

    // Find the district in DistrictList
    const district = DistrictList.find((d) => d.value === districtName);

    // If the district is being checked (turned on), fetch its coordinates
    if (!activeDistricts[districtName] && district) {
      try {
        const response = await getData(gisCoordinatesData + district.gis_id);
        if (response && response.length > 0) {
          // Parse the coordinates string into a GeoJSON object
          const geoJsonData = JSON.parse(response[0].coordinates);

          // Update district coordinates state
          setDistrictCoordinates((prev) => ({
            ...prev,
            [districtName]: geoJsonData,
          }));
        }
      } catch (error) {
        console.error(`Error fetching coordinates for ${districtName}:`, error);
        toast.error(`Failed to load coordinates for ${districtName}`);
      }
    } else if (activeDistricts[districtName]) {
      // If unchecking, remove this district's coordinates
      const newDistrictCoordinates = { ...districtCoordinates };
      delete newDistrictCoordinates[districtName];
      setDistrictCoordinates(newDistrictCoordinates);
    }

    // Update the "select all" state
    const allSelected = DistrictList.every(
      (district) => newActiveDistricts[district.value]
    );
    setSelectAllDistricts(allSelected);
  };
  const mapStateCoordinates = async () => {
    try {
      const res = await getData(gisStateCoordinates + 52); // Assuming 52 is Bihar's state_id

      if (res && res.length > 0) {
        const stateData = res[0];
        // Parse the coordinates string into a GeoJSON object
        const geoJsonData = {
          type: "Feature",
          properties: {
            name: stateData.state_name,
            state_id: stateData.state_id,
          },
          geometry: JSON.parse(stateData.coordinates),
        };
        setStateGeoJSON(geoJsonData);
      }
    } catch (error) {
      console.error("Error fetching state coordinates:", error);
      toast.error("Failed to load state coordinates");
    }
  };

  const fetchDistrictList = async () => {
    // setLoader(true);
    try {
      const response = await getData(getAllDistricts);
      if (response && Array.isArray(response)) {
        setDistrictList(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    } finally {
      // setLoader(false);
    }
  };

  const fetchCoordinates = async () => {
    setLoader(true); // Start loading
    try {
      const response = await getData(gisCoordinatesData + selectedDistrictId);
      if (response && response.length > 0) {
        const geoJsonData = JSON.parse(response[0].coordinates);
        setCoordinates(geoJsonData);
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      toast.error("Failed to load coordinates data");
    } finally {
      setLoader(false); // Stop loading
    }
  };


  const geoJsonToLayer = (geoJson) => {
    return L.geoJSON(geoJson, {
      style: {
        color: "#ff7800",
        weight: 2,
        opacity: 1,
        fillColor: "#ff7800",
        fillOpacity: 0.2,
      },
      onEachFeature: (feature, layer) => {
        if (feature.properties && feature.properties.district) {
          layer.bindPopup(feature.properties.district);
        }
      },
    });
  };
  const facilityIcons = {
    hospital: new L.Icon({
      iconUrl: 'https://cdn-icons-png.flaticon.com/512/580/580902.png',
      iconSize: [25, 25]
    }),
    school: new L.Icon({
      iconUrl: 'https://cdn-icons-png.flaticon.com/512/563/563031.png',
      iconSize: [25, 25]
    }),
    default: new L.Icon({
      iconUrl: 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
      iconSize: [25, 41]
    })
  };
  const getFacilityIcon = (type) => {
    return facilityIcons[type] || facilityIcons.default;
  };

  // Find center point for the map based on available branch locations
  const getMapCenter = () => {
    if (mapData.branches && mapData.branches.length > 0) {
      return mapData.branches[0].position;
    }
    // Default center if no branches
    return [25.5941, 85.1376];
  };
  const byteArrayToBase64 = (byteArray) => {
    const binary = new Uint8Array(byteArray).reduce((acc, byte) => acc + String.fromCharCode(byte), '');
    return btoa(binary);
  }

  const handleMarkerClick = async (id) => {
    // Only fetch if not already in state
    if (selectedData[id]) return;

    setLoadingId(id);

    try {
      const facilitymarkerdetails = getfeaturefacility.replace('{ID}', id);
      const selectdetails = await getData(facilitymarkerdetails);
      console.log('responseeee', selectdetails);

      // Save the response in state
      setSelectedData((prev) => ({ ...prev, [id]: selectdetails }));
    } catch (error) {
      console.error('Error fetching facility details:', error);
      setSelectedData((prev) => ({
        ...prev,
        [id]: { error: 'Failed to load data' },
      }));
    } finally {
      setLoadingId(null);
    }
  };


  const SearchControl = () => {
    const map = useMap();

    useEffect(() => {
      const provider = new OpenStreetMapProvider();
      const searchControl = new GeoSearchControl({
        provider,
        style: 'bar',
        showMarker: false,
        searchLabel: 'Search location...',
      });

      map.addControl(searchControl);

      // Dynamically inject CSS to style the dropdown
      const style = document.createElement('style');
      style.innerHTML = `
      /* Force black text in search results */
      .leaflet-control-geosearch .results * {
        color: black !important;
      }
      /* Background for dropdown items */
      .leaflet-control-geosearch .results > * {
        background: white !important;
        border-bottom: 1px solid #eee !important;
      }
      /* Hover effect */
      .leaflet-control-geosearch .results > *:hover {
        background: #f5f5f5 !important;
      }
    `;
      document.head.appendChild(style);

      return () => {
        map.removeControl(searchControl);
        document.head.removeChild(style); // Clean up
      };
    }, [map]);

    return null;
  };
  // console.log(panchayatName,"rrr")

  return (
    <FullScreen handle={handle}>
      <div style={{
        display: "flex",
        height: "100vh",
        fontFamily: "Arial, sans-serif",
        position: "sticky" // Add this
      }}>
        {loader && (
          <Loader
            show={loader}
            type="body"
            stack="vertical"
            message="Loading Data"
          />
        )}

        {/* Map Section */}
        <div style={{ flex: 3 }}>
          <MapContainer
            ref={mapRef}
            center={getMapCenter()}
            attributionControl={false}
            zoom={7}
            minZoom={4}
            style={{
              width: "100%",
              height: "100%",
            }}
            whenCreated={(mapInstance) => {
              mapRef.current = mapInstance;
            }}
          >
            {/* <SearchControl /> */}
            <FeatureGroup ref={featureGroupRef}>
              {/* Circles will be added here */}
              {/* <EditControl
                position="topright"
                onCreated={handleDrawCreated}
                onDeleted={handleDrawDeleted}
                draw={{
                  rectangle: true,
                  circle: true,
                  polygon: true,
                  marker: false,
                  polyline: false
                }}
              /> */}
            </FeatureGroup>
            <LayersControl position="topright" collapsed={false}>
              <LayersControl.BaseLayer name="Road View">
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="Satellite View">
                <TileLayer
                  attribution=""
                  url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                  maxZoom={20}
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer checked name="Terrain View">
                <TileLayer
                  attribution=""
                  url="https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
                  maxZoom={20}
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="Hybrid View">
                <TileLayer
                  attribution=""
                  url="https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
                  maxZoom={20}
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
              </LayersControl.BaseLayer>
            </LayersControl>
            <LocationMarker onLocationSelect={onLocationSelect} />
            {selectedFacilities?.map(facility => {
              const { latitude, longitude } = facility;

              // Check if latitude and longitude are both defined and are numbers
              if (
                typeof latitude !== 'number' ||
                typeof longitude !== 'number' ||
                isNaN(latitude) ||
                isNaN(longitude)
              ) {
                return null; // Skip this facility if lat/lon are invalid
              }

              return (
                <Marker
                  key={facility.id}
                  position={[latitude, longitude]}
                  icon={branchIcon}
                  eventHandlers={{
                    click: () => handleMarkerClick(facility.id),
                  }}
                >
                  <Popup>
                    <div>


                      {loadingId === facility.id && <p>Loading details...</p>}

                      {selectedData[facility.id]?.error && (
                        <p style={{ color: 'red' }}>{selectedData[facility.id].error}</p>
                      )}

                      {selectedData[facility.id] && !selectedData[facility.id].error && (
                        <div>
                          {/* Facilities */}
                          {selectedData[facility.id].Facilities?.map((f, idx) => (
                            <div key={idx}>
                              {/* <hr /> */}
                              <strong>Facility Name:</strong> {f["Facility Name"]}<br />
                              <strong>Facility Address:</strong> {f["Facility Address"]}
                            </div>
                          ))}

                          {/* Contacts */}
                          {selectedData[facility.id].Contacts?.length > 0 && (
                            <div>
                              <hr />
                              {/* <strong>Contacts:</strong> */}

                              {selectedData[facility.id].Contacts.map((contact, i) => (
                                <>
                                  {contact["Contact Name"] && (

                                    <span><strong>Contact Name:</strong> {contact["Contact Name"]}<br /></span>
                                  )}
                                  {contact["Job Title"] && (
                                    <span><strong>Job Title:</strong> {contact["Job Title"]}<br /></span>
                                  )}
                                  {contact["Email"] && (
                                    <span><strong>Email:</strong> {contact["Email"]}<br /></span>
                                  )}
                                  {contact["Phone Number"] && (
                                    <span><strong>Phone Number:</strong> {contact["Phone Number"]}<br /></span>
                                  )}
                                </>
                              ))}

                            </div>
                          )}

                          {/* Resources */}
                          {selectedData[facility.id].Resources?.length > 0 && (
                            <div>
                              <hr />
                              {selectedData[facility.id].Resources.map((contact, i) => (
                                <>
                                  {contact["Resource"] && (

                                    <span><strong>Resource Name:</strong> {contact["Resource"]}<br /></span>
                                  )}
                                  {contact["Activity"] && (
                                    <span><strong>Resource Activity:</strong> {contact["Activity"]}<br /></span>
                                  )}
                                  {contact["Category"] && (
                                    <span><strong>Resource Category:</strong> {contact["Category"]}<br /></span>
                                  )}
                                  {contact["Total"] && (
                                    <span><strong>Total Quantity:</strong> {contact["Total"]}<br /></span>
                                  )}
                                </>
                              ))}

                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </Popup>
                </Marker>
              );
            })}
            {mapData1?.events
              ?.filter(event => {
                const lat = parseFloat(event?.position?.[0]);
                const lng = parseFloat(event?.position?.[1]);
                return !isNaN(lat) && !isNaN(lng);
              }).map(event => {
                console.log("event======", event)
                return (
                  <Marker
                    key={`event-${event.id}`}
                    position={event?.position}
                    icon={incidentIcon}
                  >
                    <Popup>
                      <div style={{ minWidth: '200px', maxWidth: '400px' }}>
                        <p style={{ margin: '5px 0' }}><strong>Incident Name:</strong> {event.incidentName}</p>
                        <p style={{ margin: '5px 0' }}><strong>Incident Category:</strong> {event.incidentCategory}</p>
                        <p style={{ margin: '5px 0' }}><strong>Event Date and Time:</strong> {event.eventTime}</p>

                        <p style={{ margin: '5px 0' }}><strong>User Details:</strong> {event.userName + "," + event.jobTitle + "," + event.mobileNumber}</p>
                        {/* <p style={{ margin: '5px 0' }}><strong>Job Title:</strong> {event.jobTitle}</p>
                        <p style={{ margin: '5px 0' }}><strong>Phone Number:</strong> {event.mobileNumber}</p> */}
                        <p style={{ margin: '5px 0' }}><strong>Lat/Lng:</strong> {event?.position?.[0] + "/" + event?.position?.[1]}</p>

                        <p style={{ margin: '5px 0' }}><strong>Event Description:</strong> {event.action}</p>

                        {event.files && event.files.length > 0 && (
                          <div style={{
                            position: 'relative',
                            marginTop: '5px'
                          }}>
                            {/* Navigation arrows */}
                            {event.files.length > 1 && (
                              <>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setCurrentImageIndex(prev =>
                                      prev === 0 ? event.files.length - 1 : prev - 1
                                    );
                                  }}
                                  style={{
                                    position: 'absolute',
                                    left: '0',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'rgba(0,0,0,0.5)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '24px',
                                    height: '24px',
                                    cursor: 'pointer',
                                    zIndex: 1000
                                  }}
                                >
                                  &lt;
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setCurrentImageIndex(prev =>
                                      prev === event.files.length - 1 ? 0 : prev + 1
                                    );
                                  }}
                                  style={{
                                    position: 'absolute',
                                    right: '0',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'rgba(0,0,0,0.5)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '24px',
                                    height: '24px',
                                    cursor: 'pointer',
                                    zIndex: 1000
                                  }}
                                >
                                  &gt;
                                </button>
                              </>
                            )}

                            {/* Current media file */}
                            {event.files.map((file, index) => {
                              if (!file || !file.filePath) return null;
                              if (index !== currentImageIndex) return null;

                              const isVideo = file.filePath.endsWith('.mp4') ||
                                file.filePath.endsWith('.webm') ||
                                file.filePath.endsWith('.ogg');

                              return (
                                <div key={file.fileId}>
                                  {isVideo ? (
                                    <video
                                      controls
                                      style={{
                                        width: '100%',
                                        height: '150px',
                                        objectFit: 'cover',
                                        borderRadius: '4px'
                                      }}
                                    >
                                      <source
                                        src={file.filePath}
                                        type="video/mp4"
                                      />
                                      Your browser does not support the video tag.
                                    </video>
                                  ) : (
                                    <img
                                      src={file.filePath}
                                      alt="Preview"
                                      style={{
                                        width: '100%',
                                        height: '150px',
                                        objectFit: 'cover',
                                        borderRadius: '4px'
                                      }}
                                    />
                                  )}

                                  {/* Media counter */}
                                  {event.files.length > 1 && (
                                    <div style={{
                                      textAlign: 'center',
                                      marginTop: '4px',
                                      fontSize: '12px'
                                    }}>
                                      {currentImageIndex + 1} / {event.files.length}
                                    </div>
                                  )}
                                </div>
                              );
                            })}

                          </div>
                        )}
                      </div>
                    </Popup>
                  </Marker>
                );
              })}
            {facilityCoordinates?.map((facility) => (
              <Marker
                key={`facility-${facility.id}`}
                position={facility.position}
                icon={branchIcon}
                eventHandlers={{
                  click: () => handleMarkerClick(facility.id),
                }}
              >
                <Popup>
                  <div>


                    {loadingId === facility.id && <p>Loading details...</p>}

                    {selectedData[facility.id]?.error && (
                      <p style={{ color: 'red' }}>{selectedData[facility.id].error}</p>
                    )}

                    {selectedData[facility.id] && !selectedData[facility.id].error && (
                      <div>
                        {/* Facilities */}
                        {selectedData[facility.id].Facilities?.map((f, idx) => (
                          <div key={idx}>
                            {/* <hr /> */}
                            <strong>Facility Name:</strong> {f["Facility Name"]}<br />
                            <strong>Facility Address:</strong> {f["Facility Address"]}
                          </div>
                        ))}

                        {/* Contacts */}
                        {selectedData[facility.id].Contacts?.length > 0 && (
                          <div>
                            <hr />
                            {/* <strong>Contacts:</strong> */}

                            {selectedData[facility.id].Contacts.map((contact, i) => (
                              <>
                                {contact["Contact Name"] && (

                                  <span><strong>Contact Name:</strong> {contact["Contact Name"]}<br /></span>
                                )}
                                {contact["Job Title"] && (
                                  <span><strong>Job Title:</strong> {contact["Job Title"]}<br /></span>
                                )}
                                {contact["Email"] && (
                                  <span><strong>Email:</strong> {contact["Email"]}<br /></span>
                                )}
                                {contact["Phone Number"] && (
                                  <span><strong>Phone Number:</strong> {contact["Phone Number"]}<br /></span>
                                )}
                              </>
                            ))}

                          </div>
                        )}

                        {/* Resources */}
                        {selectedData[facility.id].Resources?.length > 0 && (

                          <div>
                            <hr />
                            {selectedData[facility.id].Resources.map((contact, i) => (
                              <>
                                {contact["Resource"] && (

                                  <span><strong>Resource Name:</strong> {contact["Resource"]}<br /></span>
                                )}
                                {contact["Activity"] && (
                                  <span><strong>Resource Activity:</strong> {contact["Activity"]}<br /></span>
                                )}
                                {contact["Category"] && (
                                  <span><strong> Resource Category:</strong> {contact["Category"]}<br /></span>
                                )}
                                {contact["Total"] && (
                                  <span><strong>Total Quantity:</strong> {contact["Total"]}<br /></span>
                                )}
                              </>
                            ))}

                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </Popup>
              </Marker>
            ))}
            {bmskdetails?.map((station) => (
              <Marker
                key={`bmsk-${station.id}`}
                position={[station.latitude, station.longitude]}
                icon={bmskIcon}
              >
                <Popup>
                  <div style={{ minWidth: '200px' }}>
                    {/* <h4 style={{ margin: '5px 0', color: '#4CAF50' }}>Weather Station</h4> */}
                    <p style={{ margin: '5px 0' }}><strong>District:</strong> {station.district}</p>
                    <p style={{ margin: '5px 0' }}><strong>Temperature:</strong> {station.temperature}</p>
                    <p style={{ margin: '5px 0' }}><strong>Humidity:</strong> {station.humidity}</p>
                    <p style={{ margin: '5px 0' }}><strong>Rainfall:</strong> {station.rainfall}</p>
                    <p style={{ margin: '5px 0' }}><strong>Wind Speed:</strong> {station.windSpeed}</p>
                  </div>
                </Popup>
              </Marker>
            ))}
            {filteredFacilities && filteredFacilities.length > 0 && drawnShapes.length > 0 ? (
              filteredFacilities.map((facility) => {
                if (isNaN(facility.latitude) || isNaN(facility.longitude)) return null;

                return (
                  <Marker
                    key={`filtered-facility-${facility?.id}-${drawnShapes.length}`}  // ← UNIQUE KEY
                    position={[facility?.latitude, facility?.longitude]}
                    icon={branchIcon}
                    eventHandlers={{
                      click: () => handleMarkerClick(facility?.id),
                    }}
                  >
                    <Popup>
                      <div>
                        {loadingId === facility.id && <p>Loading details...</p>}

                        {selectedData[facility.id]?.error && (
                          <p style={{ color: 'red' }}>{selectedData[facility.id].error}</p>
                        )}

                        {selectedData[facility.id] && !selectedData[facility.id].error && (
                          <div>
                            {/* Facilities */}
                            {selectedData[facility.id].Facilities?.length > 0 &&
                              selectedData[facility.id].Facilities.map((f, idx) => (
                                <div key={idx}>
                                  <strong>Facility Name:</strong> {f["Facility Name"]}<br />
                                  <strong>Facility Address:</strong> {f["Facility Address"]}
                                </div>
                              ))
                            }

                            {/* Contacts */}
                            {selectedData[facility.id].Contacts?.length > 0 && (
                              <div>
                                <hr />
                                {selectedData[facility.id].Contacts.map((contact, i) => (
                                  <div key={i}>
                                    {contact["Contact Name"] && (
                                      <span><strong>Contact Name:</strong> {contact["Contact Name"]}<br /></span>
                                    )}
                                    {contact["Job Title"] && (
                                      <span><strong>Job Title:</strong> {contact["Job Title"]}<br /></span>
                                    )}
                                    {contact["Email"] && (
                                      <span><strong>Email:</strong> {contact["Email"]}<br /></span>
                                    )}
                                    {contact["Phone Number"] && (
                                      <span><strong>Phone Number:</strong> {contact["Phone Number"]}<br /></span>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Resources */}
                            {selectedData[facility.id].Resources?.length > 0 && (
                              <div>
                                <hr />
                                {selectedData[facility.id].Resources.map((resource, i) => (
                                  <div key={i}>
                                    {resource["Resource"] && (
                                      <span><strong>Resource Name:</strong> {resource["Resource"]}<br /></span>
                                    )}
                                    {resource["Activity"] && (
                                      <span><strong>Resource Activity:</strong> {resource["Activity"]}<br /></span>
                                    )}
                                    {resource["Category"] && (
                                      <span><strong>Resource Category:</strong> {resource["Category"]}<br /></span>
                                    )}
                                    {resource["Total"] && (
                                      <span><strong>Total:</strong> {resource["Total"]}<br /></span>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </Popup>
                  </Marker>
                );
              })
            ) : null}

            {stateGeoJSON && (
              <GeoJSON
                key="state-boundary"
                data={stateGeoJSON}
                style={{
                  color: "#000000",
                  weight: 2,
                  fillColor: "transparent",
                  fillOpacity: 0.2,
                }}
                interactive={false}
                eventHandlers={{
                  click: (e) => {
                    const { lat, lng } = e.latlng;
                    console.log("State clicked at:", lat, lng);
                    onLocationSelect({
                      latitude: lat,
                      longitude: lng
                    });
                  }
                }}
                onEachFeature={(feature, layer) => {
                  if (feature.properties?.name) {
                    layer.bindPopup(`State: ${feature.properties.name}`);
                  }
                }}
              />
            )}

            {searchCoordinates && (
              <GeoJSON
                key={`search-${Date.now()}`} // Timestamp-based key for uniqueness
                data={searchCoordinates}
                style={{
                  color: "orange",
                  weight: 3,
                  opacity: 1,
                  fillColor: "orange",
                  fillOpacity: 0.3,
                  interactive: true,
                  bubblingMouseEvents: false
                }}
                interactive={true}
                eventHandlers={{
                  add: (e) => {
                    // When layer is added, automatically zoom to it
                    const bounds = e.target.getBounds();
                    if (mapRef.current && bounds.isValid()) {
                      mapRef.current.flyToBounds(bounds, {
                        padding: [50, 50],
                        duration: 1,
                        maxZoom: 12
                      });
                    }
                  },
                  click: (e) => {
                    e.originalEvent.preventDefault();
                    e.originalEvent.stopPropagation();
                    const { lat, lng } = e.latlng;
                    console.log("Search coordinate clicked at:", lat, lng);
                    onLocationSelect({
                      latitude: lat,
                      longitude: lng
                    });
                  },
                  mouseover: (e) => {
                    const layer = e.target;
                    layer.setStyle({
                      weight: 4,
                      color: "#ff6600",
                      fillOpacity: 0.5
                    });
                    layer.openTooltip();
                  },
                  mouseout: (e) => {
                    const layer = e.target;
                    layer.setStyle({
                      weight: 3,
                      color: "#ff0000",
                      fillOpacity: 0.3
                    });
                    layer.closeTooltip();
                  }
                }}
              // onEachFeature={(feature, layer) => {
              //   const displayName = feature.properties?.name || 
              //                       feature.properties?.district ||
              //                       feature.properties?.state ||
              //                       "Search Result";

              //   layer.bindTooltip(`<b>${displayName}</b>`, {
              //     permanent: false,
              //     direction: 'top',
              //     className: 'map-tooltip',
              //     sticky: true,
              //   });

              //   layer.bindPopup(`<b>${displayName}</b>`);
              // }}
              />
            )}



            {Object.entries(districtLayers).map(([gisId, geoJson]) => {
              const regionData = selectedRegions.find(region => region.gis_id === parseInt(gisId));
              const isRecentlySelected = selectedDistrictIds[selectedDistrictIds.length - 1] === gisId;

              // Find the district name from DistrictList
              const district = DistrictList.find(d => d.gis_id === parseInt(gisId));
              console.log("distriiii", district)
              const districtName = district?.value || `District ${gisId}`;
              console.log("distriiii222", districtName)

              return (
                <GeoJSON
                  key={gisId}
                  data={geoJson}
                  style={{
                    color: "#000000",
                    weight: allDistrictsSelected
                      ? 1
                      : isRecentlySelected
                        ? 3
                        : 1,
                    opacity: 1,
                    fill: true,
                    fillColor: "transparent",       // ✅ NO background fill
                    interactive: true,
                    bubblingMouseEvents: false
                  }}
                  interactive={true}
                  eventHandlers={{
                    click: (e) => {
                      e.originalEvent.preventDefault();
                      e.originalEvent.stopPropagation();
                      const { lat, lng } = e.latlng;

                      onLocationSelect({
                        latitude: lat,
                        longitude: lng
                      });
                      // Zoom to this district when clicked
                      const bounds = e.target.getBounds();
                      mapRef.current.flyToBounds(bounds, {
                        padding: [50, 50],
                        duration: 1
                      });
                    },
                    mouseover: (e) => {
                      const layer = e.target;
                      layer.setStyle({
                        weight: 2,
                        color: "#000000"
                      });

                      // Show tooltip on hover
                      layer.openTooltip();
                    },
                    mouseout: (e) => {
                      const layer = e.target;
                      const isSelected = selectedDistrictIds.includes(gisId);
                      layer.setStyle({
                        weight: isSelected ? 2 : 1,
                        color: isSelected ? "#000000" : "#000000"
                      });

                      // Close tooltip when mouse leaves
                      layer.closeTooltip();
                    }
                  }}
                  onEachFeature={(feature, layer) => {

                    // Bind tooltip with district name
                    layer.bindTooltip(`<b>${districtName}</b>`, {
                      permanent: false,
                      direction: 'top',
                      className: 'map-tooltip',
                      sticky: true,
                    });

                    if (feature.properties && feature.properties.name) {
                      layer.bindPopup(`<b>${feature.properties.name}</b>`);
                    }
                  }}
                />
              );
            })}
            {Object.entries(bmskLayers).map(([gisId, geoJson]) => {
              const regionData = selectedRegions.find(region => region.gis_id === parseInt(gisId));
              const isRecentlySelected = selectedBmskids[selectedBmskids.length - 1] === gisId;

              // Optional: If you have a list of BMSK stations with names
              const district = DistrictList.find(d => d.gis_id === parseInt(gisId));
              const districtName = district?.value || `District ${gisId}`;

              return (
                <GeoJSON
                  key={`bmsk-${gisId}`}
                  data={geoJson}
                  style={{
                    color: isRecentlySelected ? "#cc00cc" : "#FF00FF",
                    weight: isRecentlySelected ? 3 : 1,
                    opacity: 1,
                    fillColor: "#FF00FF",
                    fillOpacity: 0.3,
                    interactive: true,
                    bubblingMouseEvents: false
                  }}
                  interactive={true}
                  eventHandlers={{
                    click: (e) => {
                      e.originalEvent.preventDefault();
                      e.originalEvent.stopPropagation();
                      const { lat, lng } = e.latlng;

                      onLocationSelect({
                        latitude: lat,
                        longitude: lng
                      });

                      const bounds = e.target.getBounds();
                      mapRef.current.flyToBounds(bounds, {
                        padding: [50, 50],
                        duration: 1
                      });
                    },
                    mouseover: (e) => {
                      const layer = e.target;
                      layer.setStyle({
                        weight: 2,
                        color: "#ff0000"
                      });

                      layer.openTooltip();
                    },
                    mouseout: (e) => {
                      const layer = e.target;
                      const isSelected = selectedBmskids.includes(gisId);
                      layer.setStyle({
                        weight: isSelected ? 2 : 1,
                        color: isSelected ? "#ff0000" : "#FF00FF"
                      });

                      layer.closeTooltip();
                    }
                  }}
                  onEachFeature={(feature, layer) => {
                    layer.bindTooltip(`<b>${districtName}</b>`, {
                      permanent: false,
                      direction: 'top',
                      className: 'map-tooltip',
                      sticky: true,
                    });

                    if (feature.properties?.name) {
                      layer.bindPopup(`<b>${feature.properties.name}</b>`);
                    }
                  }}
                />
              );
            })}



            {Object.entries(blockLayers).map(([gisId, geoJson]) => {
              const regionData = selectedRegions.find(region => region.gis_id === parseInt(gisId));
              const isRecentlySelected = selectedBlockIds[selectedBlockIds.length - 1] === gisId;

              return (
                <GeoJSON
                  key={gisId}
                  data={geoJson}
                  style={{
                    color: isRecentlySelected ? "#0000ff" : "#0000FF",
                    weight: isRecentlySelected ? 3 : 1,
                    opacity: 1,
                    fillColor: "#0000FF",
                    fillOpacity: 0.4,
                    maxZoom: 14
                  }}
                  eventHandlers={{
                    click: (e) => {
                      e.originalEvent.preventDefault();
                      e.originalEvent.stopPropagation();
                      // Zoom to this block when clicked
                      const bounds = e.target.getBounds();
                      mapRef.current.flyToBounds(bounds, {
                        padding: [50, 50],
                        duration: 1
                      });
                    },
                    mouseover: (e) => {
                      const layer = e.target;
                      layer.setStyle({
                        weight: 2,
                        color: "#ff0000"
                      });
                    },
                    mouseout: (e) => {
                      const layer = e.target;
                      const isSelected = selectedBlockIds.includes(gisId);
                      layer.setStyle({
                        weight: isSelected ? 2 : 1,
                        color: isSelected ? "#ff0000" : "#0000ff"
                      });
                    }
                  }}
                  onEachFeature={(feature, layer) => {
                    const displayName = regionData?.name ||
                      (feature.properties && feature.properties.name) ||
                      `Block ${gisId}`;

                    layer.bindTooltip(`<b>${displayName}</b>`, {
                      permanent: false,
                      direction: 'top',
                      className: 'map-tooltip'
                    });

                    if (feature.properties && feature.properties.name) {
                      layer.bindPopup(`<b>${feature.properties.name}</b>`);
                    }
                  }}
                />
              );
            })}

            {Object.entries(panchayatLayers).map(([gisId, geoJson]) => {
              const regionData = selectedRegions.find(region => region.gis_id === parseInt(gisId));
              const isRecentlySelected = selectedPanchayatIds[selectedPanchayatIds.length - 1] === gisId;
              const panchayatName = panchayatNamenew[gisId] || `Panchayat ${gisId}`; // Get the stored name

              return (
                <GeoJSON
                  key={`panchayat-${gisId}`}
                  data={geoJson}
                  style={{
                    color: isRecentlySelected ? "#00aa00" : "#00aa00",
                    weight: isRecentlySelected ? 2 : 1,
                    opacity: 1,
                    fillColor: "#00aa00",
                    fillOpacity: 0.3,
                    maxZoom: 16
                  }}
                  eventHandlers={{
                    click: (e) => {
                      e.originalEvent.preventDefault();
                      e.originalEvent.stopPropagation();
                      const bounds = e.target.getBounds();
                      mapRef.current.flyToBounds(bounds, {
                        padding: [50, 50],
                        duration: 1,
                        maxZoom: 16
                      });
                    },
                    mouseover: (e) => {
                      const layer = e.target;
                      layer.setStyle({
                        weight: 2,
                        color: "#ff0000"
                      });
                    },
                    mouseout: (e) => {
                      const layer = e.target;
                      const isSelected = selectedPanchayatIds.includes(gisId);
                      layer.setStyle({
                        weight: isSelected ? 2 : 1,
                        color: isSelected ? "#ff0000" : "#00aa00"
                      });
                    }
                  }}
                  onEachFeature={(feature, layer) => {
                    // Use the stored panchayat name
                    const displayName = panchayatName || regionData?.name ||
                      (feature.properties && feature.properties.name) ||
                      `Panchayat ${gisId}`;

                    layer.bindTooltip(`<b>${displayName}</b>`, {
                      permanent: false,
                      direction: 'top',
                      className: 'map-tooltip'
                    });

                    if (feature.properties && feature.properties.name) {
                      layer.bindPopup(`<b>${feature.properties.name}</b>`);
                    }
                  }}
                />
              );
            })}

            {Object.entries(villageLayers).map(([gisId, geoJson]) => {
              const regionData = selectedRegions.find(region => region.gis_id === parseInt(gisId));
              const isRecentlySelected = selectedVillageIds[selectedVillageIds.length - 1] === gisId;

              return (
                <GeoJSON
                  key={`village-${gisId}`}
                  data={geoJson}
                  style={{
                    color: isRecentlySelected ? "#aa00aa" : "#aa00aa",
                    weight: isRecentlySelected ? 2 : 1,
                    opacity: 1,
                    fillColor: "#aa00aa",
                    fillOpacity: 0.4,
                    maxZoom: 18
                  }}
                  eventHandlers={{
                    click: (e) => {
                      e.originalEvent.preventDefault();
                      e.originalEvent.stopPropagation();
                      const bounds = e.target.getBounds();
                      mapRef.current.flyToBounds(bounds, {
                        padding: [50, 50],
                        duration: 1,
                        maxZoom: 18
                      });
                    },
                    mouseover: (e) => {
                      const layer = e.target;
                      layer.setStyle({
                        weight: 2,
                        color: "#ff0000"
                      });
                    },
                    mouseout: (e) => {
                      const layer = e.target;
                      const isSelected = selectedVillageIds.includes(gisId);
                      layer.setStyle({
                        weight: isSelected ? 2 : 1,
                        color: isSelected ? "#ff0000" : "#aa00aa"
                      });
                    }
                  }}
                  onEachFeature={(feature, layer) => {
                    const displayName = regionData?.name ||
                      (feature.properties && feature.properties.name) ||
                      `Village ${gisId}`;

                    layer.bindTooltip(`<b>${displayName}</b>`, {
                      permanent: false,
                      direction: 'top',
                      className: 'map-tooltip'
                    });

                    if (feature.properties && feature.properties.name) {
                      layer.bindPopup(`<b>${feature.properties.name}</b>`);
                    }
                  }}
                />
              );
            })}

          </MapContainer>
        </div>


      </div>
    </FullScreen>
  );
};


export default RMMap;